import React from 'react';
import { connect } from 'react-redux';
import TermsTemplate from 'view/TermsTemplate';
import Summary from '../Summary';
import Content from '../Content';
import './../terms-template.scss';
import './terms-policy.scss';

const TermsPolicy = ({ i18n }) => {
    const { locale, translations } = i18n;
    const { headline, updated, privacy, cookie, copyright } = translations[locale]['terms-policy'];

    return (
        <TermsTemplate containerStyle="terms-policy">
            <h1>{ headline }</h1>
            <main className="container">
                <Summary summary={ updated } />
                { privacy.subheading ? (<h2 className="subheading">{ privacy.subheading }</h2>) : null }
                <Summary summary={ privacy.summary } />
                <Content items={ privacy.sections } />
                { cookie.subheading ? (<h2 className="subheading">{ cookie.subheading }</h2>) : null }
                <Summary summary={ cookie.summary } />
                <Content items={ cookie.sections } tag="ul" tagStyle="disorder-list" />
                <Summary summary={ copyright } />
            </main>
        </TermsTemplate>
    );
}

export default connect(state => ({ i18n: state.i18n }))(TermsPolicy);
